
/** 执行抽奖的错误码 */
export enum LotteryExecErrCode {
  /** 已被自己使用过 */
  usedMyself = '1615659109',
  /** 已被别人使用过 */
  usedOthers = '1615659110',
  /** 活动已结束 */
  end = '1615659020',
  /** cdkey不正确 */
  wrongCdkey = '1615659100'
}

/** 执行抽奖结果状态 */
export enum LotteryExecStatus {
  /** 已被使用过 */
  used = 1,
  /** 活动已结束 */
  end,
  /** 已达领取上限 */
  limit,
  /** 积分已派完 */
  soldOut,
  /** cdkey不正确 */
  wrongCdkey
}
